(function () {
  'use strict';

  /*
   * SETINONE - Variant Gallery Filter
   *
   * 1 click  = show only images from variant metafield
   * 2nd click on same option = show all product images
   */

  if (window.__setinoneVariantGalleryLoaded) {
    return;
  }

  window.__setinoneVariantGalleryLoaded = true;

  var OPTION_SELECTOR = 'input[data-variant-option-value]';


  /*
   * Convert an image URL / filename into a clean filename.
   *
   * Example:
   * https://cdn.shopify.com/.../167651029-6.webp?v=123
   *
   * becomes:
   * 167651029-6.webp
   */
  function normalizeFilename(value) {
    if (!value) {
      return '';
    }

    value = String(value);

    try {
      value = decodeURIComponent(value);
    } catch (error) {
      // Ignore malformed encoded URLs.
    }

    value = value.split('?')[0];
    value = value.split('#')[0];
    value = value.split('/').pop();

    return value.toLowerCase().trim();
  }


  /*
   * Read the JSON map that we generated in product-gallery.liquid.
   */
  function getGalleryMap(gallery) {
    var jsonElement = gallery.querySelector(
      '[data-variant-gallery-map]'
    );

    if (!jsonElement) {
      console.warn(
        '[Variant Gallery] data-variant-gallery-map not found.'
      );

      return {};
    }

    try {
      return JSON.parse(jsonElement.textContent);
    } catch (error) {
      console.error(
        '[Variant Gallery] Invalid JSON:',
        error
      );

      return {};
    }
  }


  /*
   * Find the Shopify product form that owns the clicked option.
   */
  function getProductForm(input) {
    if (!input) {
      return null;
    }

    return input.closest(
      'form[data-product-form], form[action*="/cart/add"]'
    );
  }


  /*
   * Get the currently selected Shopify variant ID.
   */
  function getCurrentVariantId(input) {
    var form = getProductForm(input);

    if (form) {
      /*
       * Empire normally has a master product selector.
       */
      var productSelect = form.querySelector(
        '[data-product-select]'
      );

      if (
        productSelect &&
        productSelect.value
      ) {
        return String(productSelect.value);
      }


      /*
       * Fallback for themes / forms where the ID is stored
       * in a normal select or hidden input.
       */
      var idInputs = form.querySelectorAll(
        'select[name="id"], input[name="id"]'
      );

      for (var i = 0; i < idInputs.length; i++) {
        if (idInputs[i].value) {
          return String(idInputs[i].value);
        }
      }
    }


    /*
     * Last fallback: variant ID from URL.
     */
    var urlMatch = window.location.search.match(
      /[?&]variant=([0-9]+)/
    );

    if (urlMatch && urlMatch[1]) {
      return String(urlMatch[1]);
    }

    return '';
  }


  /*
   * Find the gallery associated with this product form.
   *
   * We walk upwards until we find a parent containing
   * data-product-gallery.
   */
  function getRelatedGalleries(input) {
    var node = getProductForm(input);

    if (!node) {
      node = input.parentElement;
    }

    while (
      node &&
      node !== document.body
    ) {
      if (node.querySelectorAll) {
        var galleries = node.querySelectorAll(
          '[data-product-gallery]'
        );

        if (galleries.length) {
          return galleries;
        }
      }

      node = node.parentElement;
    }

    /*
     * Product page fallback.
     */
    return document.querySelectorAll(
      '[data-product-gallery]'
    );
  }


  /*
   * Check whether a filename belongs to the variant.
   */
  function filenameMatches(
    filename,
    allowedFiles,
    allowedCount,
    sku
  ) {
    filename = normalizeFilename(filename);

    if (!filename) {
      return false;
    }


    /*
     * Main method:
     * match against custom.variant_gallery
     */
    if (
      allowedCount > 0 &&
      allowedFiles[filename]
    ) {
      return true;
    }


    /*
     * Fallback:
     * If metafield filenames couldn't be read,
     * use your SKU-based filename convention.
     *
     * Example:
     * SKU: 167651029
     * Image: 167651029-6.webp
     */
    if (
      allowedCount === 0 &&
      sku
    ) {
      sku = String(sku).toLowerCase().trim();

      if (
        filename.indexOf(sku + '-') === 0 ||
        filename.indexOf(sku + '_') === 0
      ) {
        return true;
      }
    }

    return false;
  }


  /*
   * Restore the original gallery.
   */
  function showAllImages(gallery) {
    var figures = gallery.querySelectorAll(
      '[data-variant-gallery-item]'
    );

    var thumbnails = gallery.querySelectorAll(
      '[data-variant-gallery-thumbnail]'
    );


    for (var i = 0; i < figures.length; i++) {
      figures[i].hidden = false;

      figures[i].removeAttribute(
        'data-variant-gallery-hidden'
      );
    }


    for (var j = 0; j < thumbnails.length; j++) {
      thumbnails[j].hidden = false;

      thumbnails[j].removeAttribute(
        'data-variant-gallery-hidden'
      );
    }


    gallery.removeAttribute(
      'data-variant-gallery-filter-id'
    );

    gallery.removeAttribute(
      'data-variant-gallery-filter-key'
    );


    console.log(
      '[Variant Gallery] Filter removed - showing all images.'
    );
  }


  /*
   * Filter gallery according to selected variant.
   */
  function filterGallery(
    gallery,
    variantId,
    filterKey
  ) {
    var galleryMap = getGalleryMap(gallery);

    var variantData =
      galleryMap[String(variantId)];


    /*
     * Variant doesn't exist in map:
     * don't leave an empty gallery.
     */
    if (!variantData) {
      console.warn(
        '[Variant Gallery] Variant not found:',
        variantId
      );

      showAllImages(gallery);

      return false;
    }


    var images =
      variantData.images || [];

    var sku =
      variantData.sku || '';

    var allowedFiles = {};
    var allowedCount = 0;


    /*
     * Build filename lookup table.
     */
    for (var i = 0; i < images.length; i++) {
      var normalized =
        normalizeFilename(images[i]);

      if (
        normalized &&
        !allowedFiles[normalized]
      ) {
        allowedFiles[normalized] = true;
        allowedCount++;
      }
    }


    var figures = gallery.querySelectorAll(
      '[data-variant-gallery-item]'
    );

    var thumbnails = gallery.querySelectorAll(
      '[data-variant-gallery-thumbnail]'
    );

    var matchedFigures = 0;


    /*
     * Filter large gallery media.
     */
    for (var f = 0; f < figures.length; f++) {
      var figure = figures[f];

      var figureFilename =
        figure.getAttribute(
          'data-media-filename'
        );

      var showFigure =
        filenameMatches(
          figureFilename,
          allowedFiles,
          allowedCount,
          sku
        );


      figure.hidden = !showFigure;


      if (showFigure) {
        figure.removeAttribute(
          'data-variant-gallery-hidden'
        );

        matchedFigures++;
      } else {
        figure.setAttribute(
          'data-variant-gallery-hidden',
          'true'
        );
      }
    }


    /*
     * Filter thumbnails.
     */
    for (var t = 0; t < thumbnails.length; t++) {
      var thumbnail = thumbnails[t];

      var thumbnailFilename =
        thumbnail.getAttribute(
          'data-media-filename'
        );

      var showThumbnail =
        filenameMatches(
          thumbnailFilename,
          allowedFiles,
          allowedCount,
          sku
        );


      thumbnail.hidden = !showThumbnail;


      if (showThumbnail) {
        thumbnail.removeAttribute(
          'data-variant-gallery-hidden'
        );
      } else {
        thumbnail.setAttribute(
          'data-variant-gallery-hidden',
          'true'
        );
      }
    }


    /*
     * Safety:
     * If nothing matched, restore everything rather
     * than giving the customer a blank gallery.
     */
    if (matchedFigures === 0) {
      console.warn(
        '[Variant Gallery] No matching images for variant:',
        variantId
      );

      showAllImages(gallery);

      return false;
    }


    gallery.setAttribute(
      'data-variant-gallery-filter-id',
      String(variantId)
    );

    gallery.setAttribute(
      'data-variant-gallery-filter-key',
      filterKey
    );


    /*
     * If the currently displayed main image is one
     * of the images we just hid, select the first
     * visible thumbnail using Empire's own gallery JS.
     */
    var currentFigure = gallery.querySelector(
      '[data-gallery-figure][data-gallery-selected="true"]'
    );

    if (!currentFigure) {
      currentFigure = gallery.querySelector(
        '[data-gallery-figure][aria-hidden="false"]'
      );
    }


    if (
      !currentFigure ||
      currentFigure.hidden
    ) {
      var firstVisibleThumbnail = null;

      for (
        var thumbIndex = 0;
        thumbIndex < thumbnails.length;
        thumbIndex++
      ) {
        if (!thumbnails[thumbIndex].hidden) {
          firstVisibleThumbnail =
            thumbnails[thumbIndex];

          break;
        }
      }


      if (firstVisibleThumbnail) {
        window.setTimeout(
          function () {
            firstVisibleThumbnail.click();
          },
          20
        );
      }
    }


    console.log(
      '[Variant Gallery] Showing variant:',
      variantId,
      'Images:',
      matchedFigures
    );

    return true;
  }


  /*
   * Empire updates its hidden variant ID after
   * the option is clicked.
   *
   * We wait briefly until Empire finishes updating it.
   */
  function waitForVariantAndFilter(
    input,
    galleries,
    filterKey,
    variantBeforeClick
  ) {
    var attempts = 0;
    var maxAttempts = 7;


    function checkVariant() {
      attempts++;

      var variantId =
        getCurrentVariantId(input);


      /*
       * New variant detected.
       */
      if (
        variantId &&
        (
          variantId !== variantBeforeClick ||
          attempts >= maxAttempts
        )
      ) {
        for (
          var i = 0;
          i < galleries.length;
          i++
        ) {
          filterGallery(
            galleries[i],
            variantId,
            filterKey
          );
        }

        return;
      }


      if (attempts < maxAttempts) {
        window.setTimeout(
          checkVariant,
          40
        );
      }
    }


    window.setTimeout(
      checkVariant,
      0
    );
  }


  /*
   * Handle variant box / swatch click.
   */
  function onVariantOptionClick(event) {
    var input = event.target;

    if (
      !input ||
      !input.matches ||
      !input.matches(OPTION_SELECTOR)
    ) {
      return;
    }


    var optionIndex =
      input.getAttribute(
        'data-variant-option-value-index'
      ) || '0';

    var optionValue =
      input.value || '';

    var filterKey =
      optionIndex +
      '::' +
      optionValue;


    var galleries =
      getRelatedGalleries(input);


    if (!galleries.length) {
      return;
    }


    /*
     * Was this exact same option already filtering?
     *
     * YES:
     * second click -> remove filter -> show everything.
     */
    var sameFilterActive = false;


    for (
      var i = 0;
      i < galleries.length;
      i++
    ) {
      if (
        galleries[i].getAttribute(
          'data-variant-gallery-filter-key'
        ) === filterKey
      ) {
        sameFilterActive = true;
        break;
      }
    }


    if (sameFilterActive) {
      for (
        var g = 0;
        g < galleries.length;
        g++
      ) {
        showAllImages(
          galleries[g]
        );
      }

      return;
    }


    /*
     * First click / different color:
     * allow Empire to update the variant first.
     */
    var variantBeforeClick =
      getCurrentVariantId(input);


    waitForVariantAndFilter(
      input,
      galleries,
      filterKey,
      variantBeforeClick
    );
  }


  /*
   * Event delegation works even if Shopify
   * re-renders part of the product form.
   */
  document.addEventListener(
    'click',
    onVariantOptionClick,
    false
  );

})();